import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'Icon',
  props: {
  name: {
    type: String,
    required: true
  },
  color: {
    type: String,
    default: null
  },
  size: {
    type: String as PropType<"tiny" | "small" | "medium" | "large">,
    default: null
  },
  tiny: {
    type: Boolean,
    default: false
  },
  small: {
    type: Boolean,
    default: false
  },
  medium: {
    type: Boolean,
    default: false
  },
  large: {
    type: Boolean,
    default: false
  },
  danger: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {


const props = __props

// ------------
// Icon Name ==
// ------------

const icon = computed(() => useIconLib(props.name) as string)

// ------------
// Icon Type ==
// ------------

const svgIcon = computed(() => icon.value.includes('.svg'))

// ------------
// Icon Size ==
// ------------

const iconSizes = {
  'tiny': 10,
  'small': 16,
  'medium': 32,
  'large': 64
}

const iconSize = computed(() => {
  if (svgIcon) {
    if (props.tiny) return iconSizes.tiny
    if (props.small) return iconSizes.small
    if (props.medium) return iconSizes.medium
    if (props.large) return iconSizes.large
    
    return iconSizes[props.size] || iconSizes.medium
  } else {
    return props.size || props.large ? 'large' : props.small ? 'x-small' : undefined
  }
})

// -------------
// Icon Color ==
// -------------

const iconColor = computed(() => props.color || (props.danger ? 'red' as string : undefined))


return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_unref(svgIcon))
    ? (_openBlock(), _createBlock(_component_v_img, {
        key: 0,
        src: `/images/icons/${_unref(icon)}`,
        width: _unref(iconSize),
        height: _unref(iconSize),
        class: "d-inline-block"
      }, null, 8, ["src", "width", "height"]))
    : (_openBlock(), _createBlock(_component_v_icon, {
        key: 1,
        icon: _unref(icon),
        color: _unref(iconColor),
        size: _unref(iconSize)
      }, null, 8, ["icon", "color", "size"]))
}
}

})